import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS_COSTS].GET_REPORTS_DONE_WORKS_COSTS]: {
		url: '/company/:companyId/reports/done_works_costs/',
	},
	[ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS_COSTS].GET_REPORTS_DONE_WORKS_COST]: {
		url: '/company/:companyId/reports/done_works_costs/:doneWorksCostsId/',
	},
  [ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS_COSTS].GET_REPORTS_DONE_WORKS_COST_PREVIEW]: {
		url: '/company/:companyId/reports/done_works_costs/:doneWorksCostsId/preview/',
	},
}